if (!customElements.get('cart-order-bumps')) {
  customElements.define('cart-order-bumps', class CartOrderBumps extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-order-bump]').forEach((offer) => {
        offer.querySelectorAll('[data-bump-option]').forEach((select) => select.addEventListener('change', () => this.resolveVariant(offer)));
        offer.querySelector('[data-add-bump]')?.addEventListener('click', () => this.addOffer(offer));
        this.resolveVariant(offer);
      });
      const offers = [...this.querySelectorAll('[data-order-bump]')];
      const arrows = this.querySelectorAll('.cart-order-bumps__arrow');
      arrows.forEach((arrow) => { arrow.hidden = offers.length < 2 || this.classList.contains('cart-order-bumps--stacked'); });
      this.querySelector('[data-bump-previous]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-bump-next]')?.addEventListener('click', () => this.move(1));
    }

    move(direction) {
      this.querySelector('[data-bump-list]')?.scrollBy({ left: direction * this.clientWidth * .78, behavior: 'smooth' });
    }

    resolveVariant(offer) {
      const variants = JSON.parse(offer.querySelector('[data-bump-variants]').textContent);
      const values = [...offer.querySelectorAll('[data-bump-option]')].map((select) => select.value);
      const currentId = offer.querySelector('[data-bump-variant]').value;
      const variant = values.length
        ? variants.find((item) => item.options.every((value, index) => value === values[index]))
        : variants.find((item) => String(item.id) === String(currentId));
      const resolved = variant || variants.find((item) => item.available) || variants[0];
      offer.querySelector('[data-bump-variant]').value = resolved.id;
      offer.dataset.variantPrice = resolved.price;
      offer.dataset.variantAvailable = resolved.available ? 'true' : 'false';
      const image = offer.querySelector('[data-bump-image]');
      if (image && resolved.featured_image?.src) image.src = resolved.featured_image.src;
      const button = offer.querySelector('[data-add-bump]');
      if (button) button.disabled = !resolved.available;
      this.updatePrice(offer);
    }

    updatePrice(offer) {
      const price = Number(offer.dataset.variantPrice || 0);
      const discount = Number(offer.dataset.discount || 0);
      const finalPrice = Math.round(price * (100 - discount) / 100);
      const format = (cents) => window.Shopify?.formatMoney
        ? window.Shopify.formatMoney(cents)
        : new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
          }).format(cents / 100);
      const compare = offer.querySelector('[data-bump-compare]');
      if (compare) compare.textContent = format(price);
      const priceNode = offer.querySelector('[data-bump-price]');
      if (priceNode) priceNode.textContent = format(finalPrice);
    }

    async addOffer(offer) {
      const button = offer.querySelector('[data-add-bump]');
      const error = this.querySelector('[data-bump-error]');
      button.disabled = true;
      error.hidden = true;
      try {
        const drawer = document.querySelector('cart-drawer');
        const variantId = Number(offer.querySelector('[data-bump-variant]')?.value);
        if (!Number.isInteger(variantId) || variantId <= 0) throw new Error('Please select an available variant');
        if (offer.dataset.variantAvailable !== 'true') throw new Error('This variant is sold out');
        const body = {
          id: variantId,
          quantity: 1,
          properties: {
            _offer_type: 'order_bump', _source_product: this.dataset.sourceProductId,
            _bump_index: offer.dataset.index, _discount_percent: offer.dataset.discount
          },
          sections: drawer.getSectionsToRender().map((section) => section.id).join(','),
          sections_url: window.location.pathname
        };
        const addUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
        const response = await fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add offer');
        let finalResult = result;
        if (offer.dataset.discountCode) finalResult = await this.applyBumpDiscount(offer.dataset.discountCode, drawer);
        if (!this.renderCartSections(drawer, finalResult)) await this.refreshCartDrawer(drawer);
      } catch (exception) {
        error.textContent = exception.message;
        error.hidden = false;
        button.disabled = false;
      }
    }

    async applyBumpDiscount(code, drawer) {
      if (!code) throw new Error('Order bump discount code is not configured');
      const cartResponse = await fetch(`${routes.cart_url}.js`, { cache: 'no-store' });
      const cartState = await cartResponse.json();
      const previousManagedCodes = (cartState.attributes?._bump_discount_codes || '').split(',').filter(Boolean);
      const currentCodes = (cartState.discount_codes || []).map((discount) => discount.code).filter(Boolean);
      const managedCodes = [...new Set([...previousManagedCodes, code])];
      const customerCodes = currentCodes.filter((current) => !previousManagedCodes.includes(current));
      const body = { discount: [...new Set([...customerCodes, ...managedCodes])].join(','), attributes: { _bump_discount_codes: managedCodes.join(',') } };
      if (drawer) {
        body.sections = drawer.getSectionsToRender().map((section) => section.id).join(',');
        body.sections_url = window.location.pathname;
      }
      const response = await fetch(routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error('Could not apply order bump discount');
      const updatedCart = await response.json();
      const applied = (updatedCart.discount_codes || []).some(
        (discount) => discount.code?.toLowerCase() === code.toLowerCase() && discount.applicable !== false
      );
      if (!applied) throw new Error(`Discount code ${code} is not eligible for this order bump`);
      return updatedCart;
    }

    renderCartSections(drawer, result) {
      const sectionHtml = result?.sections?.['cart-drawer'];
      if (!sectionHtml) return false;
      const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const source = html.querySelector('#CartDrawer');
      const target = drawer.querySelector('#CartDrawer');
      if (!source || !target) return false;
      target.innerHTML = source.innerHTML;
      drawer.classList.remove('is-empty');
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
      drawer.open();
      return true;
    }

    async refreshCartDrawer(drawer) {
      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, { cache: 'no-store' });
      if (!response.ok) throw new Error('Could not refresh cart drawer');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.querySelector('#CartDrawer');
      const target = drawer.querySelector('#CartDrawer');
      if (!source || !target) throw new Error('Cart drawer markup was not found');
      target.innerHTML = source.innerHTML;
      drawer.classList.remove('is-empty');
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
      drawer.open();
    }
  });
}

if (!customElements.get('offer-cart-timer')) {
  customElements.define('offer-cart-timer', class OfferCartTimer extends HTMLElement {
    connectedCallback() {
      const duration = Number(this.dataset.minutes || 10) * 60 * 1000;
      const storageKey = 'offer-cart-reservation-end';
      let end = Number(sessionStorage.getItem(storageKey));
      if (!end || end <= Date.now()) {
        end = Date.now() + duration;
        sessionStorage.setItem(storageKey, String(end));
      }
      this.render = () => {
        const remaining = Math.max(0, end - Date.now());
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const output = this.querySelector('[data-cart-timer]');
        if (output) output.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        if (remaining === 0) clearInterval(this.timer);
      };
      this.render();
      this.timer = setInterval(this.render, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('.offer-cart-item cart-remove-button button');
  if (!button) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const row = button.closest('.offer-cart-item');
  const group = row.dataset.offerGroup;
  const source = row.dataset.offerSource;
  const offerType = row.dataset.offerType;
  const lineKey = row.dataset.lineKey;
  button.disabled = true;
  try {
    const cartState = await fetch(`${routes.cart_url}.js`, { cache: 'no-store' }).then((response) => response.json());
    const updates = {};
    cartState.items.forEach((item) => {
      const sameGroup = offerType === 'bundle' && group && item.properties?._bundle_group === group;
      const sameSingleOffer = offerType === 'single' && source && String(item.properties?._source_product || '') === source;
      const selectedBump = offerType === 'order_bump' && item.key === lineKey;
      if (sameGroup || sameSingleOffer || selectedBump) updates[item.key] = 0;
    });
    const managedCodes = [cartState.attributes?._bundle_discount_code, ...(cartState.attributes?._bump_discount_codes || '').split(',')].filter(Boolean);
    const customerCodes = (cartState.discount_codes || []).map((discount) => discount.code).filter((code) => code && !managedCodes.includes(code));
    const updateResponse = await fetch(routes.cart_update_url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, discount: customerCodes.join(','), attributes: { _bundle_discount_code: '', _bump_discount_codes: '' } })
    });
    const updatedCart = await updateResponse.json();
    const drawer = document.querySelector('cart-drawer');
    const sectionResponse = await fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, { cache: 'no-store' });
    const html = new DOMParser().parseFromString(await sectionResponse.text(), 'text/html');
    const sourceDrawer = html.querySelector('#CartDrawer');
    const targetDrawer = drawer?.querySelector('#CartDrawer');
    if (sourceDrawer && targetDrawer) targetDrawer.innerHTML = sourceDrawer.innerHTML;
    drawer?.classList.toggle('is-empty', updatedCart.item_count === 0);
    drawer?.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
  } catch (error) {
    button.disabled = false;
    const errors = document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = error.message;
  }
}, true);

document.addEventListener('change', async (event) => {
  const select = event.target.closest('[data-cart-variant-editor] [data-cart-option]');
  if (!select) return;
  event.stopPropagation();
  event.stopImmediatePropagation();
  const editor = select.closest('[data-cart-variant-editor]');
  const variants = JSON.parse(editor.querySelector('[data-cart-variants]').textContent);
  const propertiesRaw = JSON.parse(editor.querySelector('[data-cart-properties]').textContent);
  // Shopify's `| json` filter renders an empty item.properties hash as `[]` instead of `{}`,
  // which the /cart/add.js endpoint rejects with "expected Array to be a Hash: properties".
  const properties = Array.isArray(propertiesRaw) ? {} : propertiesRaw;
  const values = [...editor.querySelectorAll('[data-cart-option]')].map((input) => input.value);
  const variant = variants.find((item) => item.options.every((value, index) => value === values[index]));

  const image = editor.closest('.cart-item')?.querySelector('[data-cart-image]');
  if (image && variant?.featured_image?.src) image.src = variant.featured_image.src;

  if (!variant?.available) {
    select.setCustomValidity('This combination is sold out');
    select.reportValidity();
    return;
  }
  select.setCustomValidity('');
  editor.classList.add('is-loading');
  let quantity = Number(editor.dataset.quantity || 1);
  if (variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue' && Number.isFinite(variant.inventory_quantity)) {
    quantity = Math.max(1, Math.min(quantity, variant.inventory_quantity));
  }
  try {
    const addResponse = await fetch(routes.cart_add_url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity, properties }] })
    });
    const addResponseText = await addResponse.text();
    let addResult;
    try { addResult = JSON.parse(addResponseText); } catch (parseError) {
      throw new Error(`Add failed, non-JSON response (HTTP ${addResponse.status}): ${addResponseText.slice(0, 300)}`);
    }
    if (!addResponse.ok || addResult.status) {
      console.error('Cart add failed for variant', variant.id, addResult);
      const detail = addResult.description || addResult.message || JSON.stringify(addResult);
      throw new Error(`Add failed (HTTP ${addResponse.status}): ${detail}`);
    }
    const removeResponse = await fetch(routes.cart_update_url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: { [editor.dataset.lineKey]: 0 } })
    });
    const removeResponseText = await removeResponse.text();
    let removeResult;
    try { removeResult = JSON.parse(removeResponseText); } catch (parseError) {
      throw new Error(`New variant was added, but removal returned non-JSON (HTTP ${removeResponse.status}): ${removeResponseText.slice(0, 300)}`);
    }
    if (!removeResponse.ok || removeResult.status) {
      console.error('Cart line removal failed for line', editor.dataset.lineKey, removeResult);
      const detail = removeResult.description || removeResult.message || JSON.stringify(removeResult);
      throw new Error(`New variant was added, but the previous one could not be removed (HTTP ${removeResponse.status}): ${detail}`);
    }
    const drawer = document.querySelector('cart-drawer');
    const sectionResponse = await fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, { cache: 'no-store' });
    const html = new DOMParser().parseFromString(await sectionResponse.text(), 'text/html');
    const sourceDrawer = html.querySelector('#CartDrawer');
    const targetDrawer = drawer?.querySelector('#CartDrawer');
    if (!sourceDrawer || !targetDrawer) throw new Error('Could not refresh the cart');
    targetDrawer.innerHTML = sourceDrawer.innerHTML;
    drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
  } catch (error) {
    editor.classList.remove('is-loading');
    const errors = document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = error.message;
  }
}, true);
